import './BonusPage.css';

import logoImage from './../../image/logo.svg';
import loadingIcon from './../../image/loading-icon.svg';
import copyIcon from './../../image/copy-icon.svg';

const BonusPage = () => {
    return (
        <div className='bonus__wrapper'>
            <div className='bonus__logo'>
                <img src={logoImage} alt='Logo' />
            </div>
            <div className='bonus__main'>
                <div className='bonus__main_info'>
                    <h3 className='bonus__title'>
                        Приглашай друзей и получай бонусы
                    </h3>
                    <div className='bonus__items'>
                        <div className='bonus__item'>
                            <h5>Бонус 1</h5>
                            <p>Условие 1</p>
                        </div>
                        <div className='bonus__item'>
                            <h5>Бонус 1</h5>
                            <p>Условие 1</p>
                        </div>
                        <div className='bonus__item'>
                            <h5>Бонус 2</h5>
                            <p>Условие 2</p>
                        </div>
                        <div className='bonus__item'>
                            <h5>Бонус 3</h5>
                            <p>Условие 3</p>
                        </div>
                    </div>
                </div>

                <div className='bonus__main_frinds'>
                    <div className='bonus__frind_title'>
                        <h3>Ваши друзья:</h3>
                        <p>13</p>
                    </div>
                    <div className='bonus__friends_items'>
                        <div className='bonus__friends_item'>
                            <div className='bonus__friends_info'>
                                <img src={loadingIcon} />
                                <div className='bonus__friends_name'>
                                    <h4>Имя Фамилия</h4>
                                    <p>Уровень 1</p>
                                </div>
                            </div>
                            <div className='bonus__friends_count'>
                                Бонусы: <span>156</span>
                            </div>
                        </div>

                        <div className='bonus__friends_item'>
                            <div className='bonus__friends_info'>
                                <img src={loadingIcon} />
                                <div className='bonus__friends_name'>
                                    <h4>Имя Фамилия</h4>
                                    <p>Уровень 1</p>
                                </div>
                            </div>
                            <div className='bonus__friends_count'>
                                Бонусы: <span>156</span>
                            </div>
                        </div>

                        <div className='bonus__friends_item'>
                            <div className='bonus__friends_info'>
                                <img src={loadingIcon} />
                                <div className='bonus__friends_name'>
                                    <h4>Имя Фамилия</h4>
                                    <p>Уровень 1</p>
                                </div>
                            </div>
                            <div className='bonus__friends_count'>
                                Бонусы: <span>156</span>
                            </div>
                        </div>

                        <div className='bonus__friends_item'>
                            <div className='bonus__friends_info'>
                                <img src={loadingIcon} />
                                <div className='bonus__friends_name'>
                                    <h4>Имя Фамилия</h4>
                                    <p>Уровень 1</p>
                                </div>
                            </div>
                            <div className='bonus__friends_count'>
                                Бонусы: <span>156</span>
                            </div>
                        </div>
                    </div>
                    <div className='bonus__friends_btns'>
                        <button className='bonus__friends_btn'>
                            Пригласить
                        </button>
                        <button className='bonus__friends_copy'>
                            <img src={copyIcon} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BonusPage;
